import { DashboardLayout } from '@/components/layout/DashboardLayout';
import Ella360Dashboard from '@/components/compliance/Ella360Dashboard';

export default function Ella360() {
  return (
    <DashboardLayout>
      <Ella360Dashboard />
    </DashboardLayout>
  );
}
